import { useProductPageStore } from '../../contexts/ProductPageStore'
import { getReviewImages } from './fetches/powerReviews'
import styles from './reviewSection.module.scss'

import { useEffect, useRef, useState } from 'react'

import ErrorBoundary from 'Clutch/UtilityComponents/ErrorBoundary'
import Image from 'next/image'

import Modal from 'Clutch/Components/Modal/ModalWithPortal'

import Carousel from 'Clutch/Organisms/Carousel'

import Panel from 'Clutch/Atoms/Panel'
import Typography from 'Clutch/Atoms/Typography'

const ReviewImages = () => {
  const skuBaseNumber = useProductPageStore((x) => x.skuBaseNumber)
  const powerReviewsMerchantId = useProductPageStore((x) => x.powerReviewsMerchantId)
  const powerReviewsApiKey = useProductPageStore((x) => x.powerReviewsApiKey)
  const [customerImageUrls, setCustomerImageUrls] = useState([])
  const [nextPageUrl, setNextPageUrl] = useState(null)
  const [imageIndex, setImageIndex] = useState(0)
  const imageViewerRef = useRef(null)

  useEffect(() => {
    LoadReviewImages(
      nextPageUrl,
      skuBaseNumber,
      powerReviewsMerchantId,
      powerReviewsApiKey,
      setCustomerImageUrls,
      setNextPageUrl,
    )
  }, [])

  if (customerImageUrls.length === 0) {
    return false
  }

  return (
    <>
      <Typography font={'bold'}>Customer Photos</Typography>
      <Typography>
        See how our customers are using their products in real world application. These photos shared are real and
        showcase how users find value in using these products.
      </Typography>
      <Panel className={styles.image_bar}>
        <Carousel
          id={'pdp_review_images'}
          layer={1}
          endOfPatternInViewCallback={() => {
            if (nextPageUrl)
              LoadReviewImages(
                nextPageUrl,
                skuBaseNumber,
                powerReviewsMerchantId,
                powerReviewsApiKey,
                setCustomerImageUrls,
                setNextPageUrl,
              )
          }}
        >
          {customerImageUrls.map((url, i) => {
            if (!url) return false
            return (
              <ErrorBoundary key={`image_bar_review_${i}`}>
                <Carousel.Item className={styles.image_carousel_item_override}>
                  <div>
                    <Panel layer={0} className={styles.image_thumbnail}>
                      <div className={styles.image_dimensions}>
                        <Image
                          src={`https:${url}`}
                          fill
                          sizes={'72px'}
                          className={styles.image_contain}
                          alt={'Customer review image'}
                          onClick={() => {
                            setImageIndex(i)
                            if (imageViewerRef?.current) imageViewerRef.current.open()
                          }}
                        />
                      </div>
                    </Panel>
                  </div>
                </Carousel.Item>
              </ErrorBoundary>
            )
          })}
        </Carousel>
      </Panel>
      <ImageViewer
        ref={imageViewerRef}
        customerImageUrls={customerImageUrls}
        index={imageIndex}
        setImageIndex={setImageIndex}
        nextPageUrl={nextPageUrl}
        setCustomerImageUrls={setCustomerImageUrls}
        setNextPageUrl={setNextPageUrl}
      />
    </>
  )
}

const ImageViewer = ({
  customerImageUrls,
  index,
  setImageIndex,
  nextPageUrl,
  setCustomerImageUrls,
  setNextPageUrl,
  ref,
}) => {
  const skuBaseNumber = useProductPageStore((x) => x.skuBaseNumber)
  const powerReviewsMerchantId = useProductPageStore((x) => x.powerReviewsMerchantId)
  const powerReviewsApiKey = useProductPageStore((x) => x.powerReviewsApiKey)

  if (!customerImageUrls || customerImageUrls.length === 0) {
    return false
  }

  const url = customerImageUrls[index ?? 0]

  const handlePaginationLeft = () => {
    if (index > 0) {
      setImageIndex(index - 1)
    } else {
      setImageIndex(customerImageUrls.length - 1)
    }
  }

  const handlePaginationRight = () => {
    if (index < customerImageUrls.length - 1) {
      setImageIndex(index + 1)
    } else {
      if (nextPageUrl)
        LoadReviewImages(
          nextPageUrl,
          skuBaseNumber,
          powerReviewsMerchantId,
          powerReviewsApiKey,
          setCustomerImageUrls,
          setNextPageUrl,
        )
      else setImageIndex(0)
    }
  }

  return (
    <Modal
      id="review_image_viewer"
      outsideClick
      ref={ref}
      hidePaginationOnMobile={false}
      pagination
      onPaginationLeft={handlePaginationLeft}
      onPaginationRight={handlePaginationRight}
    >
      <div className={styles.fullSizeImage}>
        <Image
          src={`https:${url}`}
          sizes="(min-width: 768px) 44vw,(min-width: 1336px) 60vw, 95vw"
          className={styles.image_contain}
          fill
          alt={'Customer review image'}
        />
      </div>
    </Modal>
  )
}

function LoadReviewImages(
  nextPageUrl,
  skuBaseNumber,
  powerReviewsMerchantId,
  powerReviewsApiKey,
  setCustomerImageUrls,
  setNextPageUrl,
) {
  getReviewImages(nextPageUrl, skuBaseNumber, powerReviewsMerchantId, powerReviewsApiKey).then((data) => {
    if (data) {
      const imageUrls = data.results
        .map((x) => {
          return x.reviews.map((y) => y.media.map((z) => z.uri)).flat()
        })
        .flat()
        .filter((z) => z && !z.includes('youtube'))
      setCustomerImageUrls((state) => [...state, ...imageUrls])
      setNextPageUrl(data.paging.next_page_url)
    }
  })
}

export default ReviewImages
